<template>
  <div class="choice">
    <div class="choiceContent">
      <div class="title fontSize14">
        <span>{{ no + 1 }}、</span>
        <!-- <span class="">【{{ quesMap[info.type] }}】</span> -->
        <span v-html="reformHtml(info.content)"></span>
      </div>
      <div class="list">
        <!-- 单选题 -->
        <template v-if="info.type == 'SINGLECHOICE'">
          <div v-for="(item, index) in info.options" :key="index" class="li" @click="choose(item.alisa)" :class="{
            on: value == item.alisa,
            right:
              value == item.alisa && info.answer == item.alisa && readOnly,
            error:
              value == item.alisa && info.answer != item.alisa && readOnly,
          }">
            <i class="el-icon-success unit d-flex d-flex-middle d-flex-center" v-if="value == item.alisa" ></i>
            <div class="unit d-flex d-flex-middle d-flex-center" v-else></div>
            
            <div class="txt" >{{ item.alisa }}、<span v-html="reformHtml(item.text)"></span></div>
          </div>
          <div class="next_last">
            <el-button type="info" size="mini" @click="$emit('lastNext', 'last')" v-if="lastNext">上一题</el-button>
            <el-button type="danger" size="mini" class="ml" @click="$emit('lastNext', 'next')"
              v-if="lastNext">下一题</el-button>
            <el-button type="warning" size="mini" class="ml" @click="$emit('submit', info.id)"
              v-if="value && !readOnly && submit">提交</el-button>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" :class="isOne ? '': 'noMargin bottomBorder'" v-if="readOnly">
            <div class="stjx-title" :class="isOne ? '': 'noLine noPadding'">试题解析</div>
            <!-- <div>您的答案：{{ value }}</div>
            <div class="bzda">正确答案：<span class="paper_blue">{{ info.answer }}</span></div>
            <div class="stjx">试题解析：<span v-html="reformHtml(info.analysis)"></span></div> -->
            <div>您的答案：<span class="cRed">{{value }}</span></div>
            <div class="bzda">正确答案：<span class="cGreed">{{ info.answer }}</span></div>
            <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(info.analysis||info.resolve)"></span></div>
          </div>
        </template>
        <!-- 多选题 -->
        <template v-if="info.type == 'MULTIPLECHOICE'">
          <div v-for="(item, index) in info.options" :key="index" class="li" @click="chooseM(item.alisa)" :class="{
            on: value.includes(item.alisa),
            right:
              !!value.includes(item.alisa) && info.answer.indexOf(item.alisa) != -1 && readOnly,
            error:
              !!value.includes(item.alisa) && info.answer.indexOf(item.alisa) == -1 && readOnly,
          }">
            <img v-if="value.includes(item.alisa)" class="unit d-flex d-flex-middle d-flex-center" src="../../assets/images/icon/check.png" style="border-radius: 4px; width: 16px; height: 16px; top: 2px;" alt="" width="16" height="16">
            <div v-else class="unit d-flex d-flex-middle d-flex-center" style="border-radius: 4px; width: 16px; height: 16px; top: 2px;"></div>
            
            <div class="txt" >
              {{ item.alisa }}、<span v-html="reformHtml(item.text)" ></span>
            </div>
          </div>
          <div class="next_last">
            <el-button type="info" size="mini" @click="$emit('lastNext', 'last')" v-if="lastNext">上一题</el-button>
            <el-button type="danger" size="mini" class="ml" @click="$emit('lastNext', 'next')"
              v-if="lastNext">下一题</el-button>
            <el-button type="warning" size="mini" class="ml" @click="$emit('submit', info.id)"
              v-if="value && !readOnly && submit">提交</el-button>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" :class="isOne ? '': 'noMargin bottomBorder'" v-if="readOnly">
            <div class="stjx-title" :class="isOne ? '': 'noLine noPadding'">试题解析</div>
            <!-- <div>您的答案：<span v-if="value">{{ value }}</span></div>
            <div class="bzda">正确答案：<span class="paper_blue">{{ info.answer }}</span></div>
            <div class="stjx">试题解析：<span v-html="reformHtml(info.analysis)"></span></div> -->
            <div>您的答案：<span class="cRed">{{value }}</span></div>
            <div class="bzda">正确答案：<span class="cGreed">{{ info.answer }}</span></div>
            <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(info.analysis||info.resolve)"></span></div>
          </div>
        </template>
        <!-- 判断题 -->
        <template v-if="info.type == 'JUDGMENT'">
          <div class="li" @click="choose('Y')" :class="{
            on: value == 'Y',
            right: value == 'Y' && info.answer == info.answer && readOnly,
            error: value == 'Y' && info.answer != 'Y' && readOnly,
          }">
              <i class="el-icon-success unit d-flex d-flex-middle d-flex-center" v-if="value == 'Y'" style="width: 16px; height: 16px; top: 2px;"></i>
            <div class="unit d-flex d-flex-middle d-flex-center" v-else></div>
            
            <div class="txt">正确</div>
          </div>
          <div class="li" @click="choose('N')" :class="{
            on: value == 'N',
            right: value == 'N' && info.answer == info.answer && readOnly,
            error: value == 'N' && info.answer != 'N' && readOnly,
          }">
            <i class="el-icon-success unit d-flex d-flex-middle d-flex-center" v-if="value == 'N'" style="width: 16px; height: 16px; top: 2px;"></i>
            <div class="unit d-flex d-flex-middle d-flex-center" v-else></div>
            <div class="txt">错误</div>
          </div>
          <div class="next_last">
            <el-button type="info" size="mini" @click="$emit('lastNext', 'last')" v-if="lastNext">上一题</el-button>
            <el-button  type="danger" size="mini" class="ml" @click="$emit('lastNext', 'next')"
              v-if="lastNext">下一题</el-button>
            <el-button type="warning" size="mini" class="ml" @click="$emit('submit', info.id)"
              v-if="value && !readOnly && submit">提交</el-button>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" :class="isOne ? '': 'noMargin bottomBorder'" v-if="readOnly">
            <div class="stjx-title" :class="isOne ? '': 'noLine noPadding'">试题解析</div>
            <div>您的答案：<span class="cRed" v-if="value == 'Y'">正确</span><span class="paper_red"
                v-if="value == 'N'">错误</span></div>
            <div class="bzda">正确答案：<span class="cGreed">{{ info.answer == "N" ? "错误" : "正确" }}</span></div>
            <div class="stjx">试题解析：<span class="cGrey" v-html="reformHtml(info.analysis||info.resolve)"></span></div>
            
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap } from "@/utils/enum.js";
export default {
  name: "choice",
  props: {
    info: {},
    readOnly: false,
    lastNext: false,
    submit: false,
    value: {
      default: "",
    },
    check: {},
    no: '',
    isOne: false,
  },
  data () {
    return {
      quesMap,
    };
  },
  methods: {
    reformHtml (html) {
      if(!html){
        return html
      }
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    choose (value) {
      if (!this.readOnly) {
        this.$emit("input", value);
      }
    },
    chooseM (value) {
      if (!this.readOnly) {
        let data = this.value || "";
        if (data.includes(value)) {
          data = data.replace(value, "");
        } else {
          data += value;
        }
        if (data.length > 1) {
          data = data.split("").sort().join("");
        }
        this.$emit("input", data);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.choice {
  padding-left: 12px;
  .paper_blue {
    color: #3677EA;
  }

  .paper_red {
    color: #FF2929;
  }

  .next_last {
    text-align: right;
    // border-bottom: 1px solid #D2D2D2;
    // padding: 50px 0;
  }

  .choiceContent {
    .title {
      margin-bottom: 8px;
      font-weight: 400;
      font-size: 16px;
      color: #1A1A1A;
    }

    .list {
      .li {
        position: relative;
        box-sizing: border-box;
        padding: 0 0 0 30px;
        line-height: 20px;
        // margin: 15px 0;
        margin-bottom: 8px;
        cursor: pointer;
        border-radius: 5px;

        .unit {
          position: absolute;
          top: 2px;
          left: 5px;
          width: 16px;
          height: 16px;
          border: 1px solid #999;
          border-radius: 50%;
          // font-size: 12px;
          text-align:center;
          line-height: 16px;

        }

        .txt {
          width: 100%;
          word-break: break-all;
          font-size: 14px;
        }

        &.on {
          .unit {
            // border-color: #E1321A;
            // background-color: #E1321A;
            color: #E1321A;
          border: none;
          font-size: 18px;
          left: 4px;
        }
        }
      }
    }
    .noMargin{
      margin:0 !important;
      .noLine {
        padding-top:10px !important;
        margin: 0;
        display: none;
      }
    }
    
    .analysisBox {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      padding: 5px 10px;

      div {
        margin: 20px 0;
      }

      .stjx {
        display: flex;

        span {
          width: 420px;
          display: inline-block;
        }
      }

      .stjx-title {
        text-align: center;
        border-top: 1px solid #D2D2D2;
        padding-top: 30px;
        font-size: 14px;
        color: #E03019;
      }
    }
  }
}
</style>
